import { http } from 'shared/api/http';

const BASE = '/api/v1/pilates/sms';

export const smsApi = {
  /* ---------------- Enable request (mail) ---------------- */
  requestEnable() {
    const url = `${BASE}/enable-request`;
    return http(url, { method: 'POST' });
  },

  /* ---------------- Company sms (module/quota) ---------------- */
  getCompany() {
    return http(`${BASE}/me/company`, { method: 'GET' });
  },

  /* ---------------- Settings (automation) ---------------- */
  getSettings() {
    const url = `${BASE}/me/settings`;
    return http(url, { method: 'GET' });
  },

  updateSettings(dto) {
    const url = `${BASE}/me/settings`;
    return http(url, { method: 'PUT', body: dto });
  },

  /* ---------------- Test sms ---------------- */
  validateTest(payload) {
    const url = `${BASE}/me/test/validate`;
    return http(url, { method: 'POST', body: payload });
  },

  sendTest(payload) {
    const url = `${BASE}/me/test`;
    return http(url, { method: 'POST', body: payload });
  },

  /* ---------------- Manual sms ---------------- */
  sendManual(payload) {
    const url = `${BASE}/me/send`;
    return http(url, { method: 'POST', body: payload });
  },

  /* ---------------- Sms logs ---------------- */
  getLogs() {
    const url = `${BASE}/me/logs`;
    return http(url, { method: 'GET' });
  },

  updateCompany(dto) {
    return http(`${BASE}/me/company`, { method: 'PUT', body: dto });
  },

  /* ---------------- Blocked numbers ---------------- */
  getBlockedNumbers() {
    return http(`${BASE}/me/blocked-numbers`, { method: 'GET' });
  },

  addBlockedNumber(dto) {
    return http(`${BASE}/me/blocked-numbers`, { method: 'POST', body: dto });
  },

  removeBlockedNumber(phone) {
    const q = new URLSearchParams({ phone: phone ?? '' }).toString();
    return http(`${BASE}/me/blocked-numbers?${q}`, { method: 'DELETE' });
  },
};
